export default {
  debug: true,
  api: {
    version: 'mrapi',
    protocole: 'http',
    host: 'localhost',
    port: '',
    applicationToken: 'null',
    address: function () {
      return this.protocole +
      '://' +
      this.host +
      (this.port !== '' ? ':' + this.port : '') +
      '/' +
      (this.version !== '' ? this.version + '/' : '')
    }
  },
  crypto: {
    secret: 'streammind'
  },
  language: 'en',
  authMode: 'ALL'
}
